import { connect } from 'react-redux'
import get from 'lodash/get';

import { mapState } from '../../components/sections/cars/static.carMapState'

import {
  changeCarMapState as onChangeCarMapState
} from '../../actions/carMapStateActions'

const mapStateToProps = (state) => ({
  carMapState: {
    dataState: state.carMapState.dataState,
    mapSize: get(state, ['carMapState', 'mapSize'], mapState.baseSize.name),
  }
});

const mapDispatchToProps = {
  onChangeCarMapState,
}

const withCarMapState = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withCarMapState }